jQuery(document).ready(function ($) {
  if (document.body.classList.contains("block-editor-page")) return;

  const onScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };

    document.addEventListener("longevity:scroll-ready", runOnce, {
      once: true,
    });
    setTimeout(runOnce, 0);
  };

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(() => onScrollReady(initImageText));
  } else {
    onScrollReady(initImageText);
  }

  function initImageText() {
    const blocks = document.querySelectorAll(".js-image-text");
    if (!blocks.length) return;

    if (typeof window.gsap === "undefined") return;
    const gsap = window.gsap;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (_) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((el) => {
      if (el.dataset.itInit === "1") return;
      el.dataset.itInit = "1";

      const items = el.querySelectorAll(".js-it-item");
      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 18 });

      const tl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 0.9 },
        ...(ScrollTrigger
          ? { scrollTrigger: { trigger: el, start: "top 80%", once: true } }
          : {}),
      });

      tl.to(
        items,
        { autoAlpha: 1, y: 0, stagger: 0.12, clearProps: "transform" },
        0,
      );
    });
  }
});
